/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_Member_Login_Method_Granted_DescInputs */



/**
* | output |
* | --- |
* | "An additional way to sign in was opened for the member. They can now use it alongside any method they already had." |
*
* @param {Audit_Details_Member_Login_Method_Granted_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_member_login_method_granted_desc = /** @type {((inputs?: Audit_Details_Member_Login_Method_Granted_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Member_Login_Method_Granted_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Für das Mitglied wurde ein zusätzlicher Anmeldeweg geöffnet. Es kann ihn zusätzlich zu den bereits vorhandenen Methoden nutzen.")
	return /** @type {LocalizedString} */ ("An additional way to sign in was opened for the member. They can now use it alongside any method they already had.")
});